import { useState } from 'react'
import { WrapperContext } from '../../../interfaces/contexts'
import { ModalPicker } from '../../molecules/modalPicker'
import { CartDrawer } from '../../molecules/cartDrawer'

export const Wrapper = ({ className = '', style, children }) => {
  const [initModal, setInitModal] = useState(null)
  const [carts, setCarts] = useState(null)
  const [initDrawer, setInitDrawer] = useState(null)

  return (
    <div className={`t-wrapper ${className}`} style={style}>
      <WrapperContext.Provider
        value={{
          initModal: { state: initModal, setState: setInitModal },
          carts: { state: carts, setState: setCarts },
          initDrawer: { state: initDrawer, setState: setInitDrawer },
        }}
      >
        <div className="t-wrapper__container">{children}</div>
        <ModalPicker />
        <CartDrawer />
        <div className="__ads">
          <marquee direction="left">
            {`Chương trình ưu đãi dành cho sản phẩm Sách,nguồn tài nguyên số, thư
            viện điện tử, thiết bị trường học từ 1.11-31.12`.toUpperCase()}
          </marquee>
        </div>
      </WrapperContext.Provider>
    </div>
  )
}
